import React, { Component } from 'react';
import Utils from '../modules/Utils';

class ChartArc extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data,
      width: props.width,
      height: props.height,
      margin: props.margin
    };
  }

  componentDidMount() {
    this.loadD3();
  }

  componentDidUpdate() {
    this.loadD3();
  }

  loadD3() {
      if(!window.d3) {
        const script = document.createElement('script');
        script.src = 'https://d3js.org/d3.v7.min.js';
        script.async = true;
        document.body.appendChild(script);
        script.onload = () => {
          this.renderChart();
        };
      } else {
          this.renderChart();
      }
  }

  renderChart() {
        const { data, width, height, margin } = this.state;
        const percent = this.props.percent ? this.props.percent : 50 ;
        const svg = d3.select(this.refs.svg);
        console.log("renderChart ARC DATA", data);

        // Compute the dimensions; the width is provided by Observable.
        //const height = Math.min(500, width / 2);
        const outerRadius = height / 2 - 10;
        //const innerRadius = outerRadius * 0.75;
        const innerRadius = outerRadius * 0.5;

        // https://tauday.com/tau-manifesto
        const tau = 2 * Math.PI;

        // Create the SVG container, and apply a transform such that the origin is the
        // center of the canvas. This way, we don’t need to position arcs individually.
        //const svg = d3.create("svg")
        //    .attr("viewBox", [0, 0, width, height]);
        const g = svg.append("g").attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");

        // An arc function with all values bound except the endAngle. So, to compute an
        // SVG path string for a given angle, we pass an object with an endAngle
        // property to the arc function, and it will return the corresponding string.
        const arc = d3.arc()
            .innerRadius(innerRadius)
            .outerRadius(outerRadius)
            .startAngle(0);

        // Add the background arc, from 0 to 100% (tau).
        const background = g.append("path")
            .datum({endAngle: tau})
            .style("fill", "white")
            .attr("d", arc);

        // Add the foreground arc in orange, currently showing 12.7%.
        let fill = !Utils.empty(this.props.fill) ? this.props.fill : "blue";
        const foreground = g.append("path")
            .datum({ endAngle: (percent / 100) * tau })
            .style("fill", fill)
            .attr("d", arc);

        // Add the percentage text
        if (percent !== null) {
            const text = g.append("text")
                .attr("text-anchor", "middle")
                .attr("font-family", "Arial, sans-serif")
                .attr("font-stretch", "condensed")
                .attr("fill", "#222")
                .attr("dy", "0.3em")
                .text(`${percent}%`);
        }

    }

    render() {
        return (
            <svg ref="svg" width={this.state.width} height={this.state.height}></svg>
        );
    }
}

export default ChartArc;